import {config, request} from 'Utils';

/*获取购销单位数据*/
export function getGouXiaoUnitList(param) {
    return request(`${config.server}/api/v1/dms/dmsPurchase/list`, {
        method: 'post',
        body: {...param}
    });
}

export function deleterRecord(param) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/delete`, {
        method: 'get',
        body: {...param}
    });
}


/*获取订单列表数据*/
export function getOrderList(param) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/list`, {
        method: 'post',
        body: {...param}
    });
}

/*获取出库单明细*/
export function getDeliveryDetailList(param) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/getDeliveryDetailList`, {
        method: 'post',
        body: {...param}
    });
}

/*提交订单数据*/
export function saveOrder(param) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/saveOrder`, {
        method: 'post',
        body: {...param}
    });
}

/*获取详情*/
export function getOrderDetail(id) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/detail?id=${id}`, {
        method: 'get',
    });
}

export function pushEsign(id) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/pushEsign?id=${id}`, {
        method: 'get',
    });
}

export function viewEsign(id) {
    return request(`${config.server}/api/v1/dms/tgTransTransportSplitHeader/viewEsign?id=${id}`, {
        method: 'get'
    });
}

export function listSecondList(param) {
    return request(`${config.server}/api/v1/dms/employee/orderSecondList`, {
        method: 'post',
        body: param,
    });
}


// WEBPACK FOOTER //
// ./src/service/transportSplit/index.js